/*
**  FIS AI Code Assistant Policy Compliance
**  This file has been developed partially with the assistance of GitHub Copilot
**  AI coding assistance started: 07/03/2025
**  Developer notes: 
*/ 

// Idle timeout component to handle user inactivity and session management

import { ConfirmationModal } from 'components/Modals/ConfirmationModal/ConfirmationModal';
import config from 'config';
import IdleTimer from 'react-idle-timer';
import { Component } from 'react';

let idleTimeoutRef: any = null;
let logoutTimer: any = null;
const NOTIFICATION_POPUP_WAIT_TIME = 5 * 60 * 1000;

interface IdleTimeoutProps {
  logout: () => void;
  isReportPending?: boolean;
  allToastDetails?: any[];
  isToastAvailable?: boolean;
}

interface IdleTimeoutState {
  showExtendSessionDialog: boolean;
}

class IdleTimeout extends Component<IdleTimeoutProps, IdleTimeoutState> {
  constructor(props: IdleTimeoutProps) {
    super(props);
    this.state = {
      showExtendSessionDialog: false,
    };
  }

  private logoutUser = () => {
    this.props.logout();
  };

  private continueUsingApp = () => {
    if (logoutTimer) {
      clearTimeout(logoutTimer);
      logoutTimer = null;
    }
    if (idleTimeoutRef) {
      idleTimeoutRef.reset();
    }
    this.setState({ showExtendSessionDialog: false });
  };

  private idlePopupDispatch = () => {
    this.setState({ showExtendSessionDialog: true });
  };

  private handleOnIdle = () => {
    const { isReportPending, allToastDetails = [], isToastAvailable } = this.props;
    
    if (isReportPending || allToastDetails.length > 0 || isToastAvailable) {
      this.continueUsingApp();
    } else {
      this.idlePopupDispatch();
      logoutTimer = setTimeout(this.logoutUser, NOTIFICATION_POPUP_WAIT_TIME);
    }
  };

  private onCloseExtendSessionDialog = () => {
    this.setState({ showExtendSessionDialog: false });
  };

  public render() {
    return (
      <>
        <IdleTimer
          ref={(ref: any) => {
            idleTimeoutRef = ref;
          }}
          element={document}
          stopOnIdle={true}
          timeout={config.sessionTimeout}
          onIdle={this.handleOnIdle}
        />
        <ConfirmationModal isModalOpen={this.state.showExtendSessionDialog}
          modalHeader="You have been idle for a while."
          messages={['Do you want to continue using Genesis?']}
          onCloseModal={this.logoutUser}
          onConfirm={this.continueUsingApp}
          showOperationConfirmedBtn={true}
        />
      </>
    );
  }
}

export default IdleTimeout;
